export default function reducer(
  state = {
    orderInventory: [],
    fetching: false,
    fetched: false,
    error: null,
    lastQueryParameters: null,
    activeRequestId: null,
  },
  action,
) {
  switch (action.type) {
    case "FETCH_ORDER_INVENTORY_PENDING": {
      return {
        ...state,
        fetching: true,
        activeRequestId: action.meta?.requestId || null,
      };
    }
    case "FETCH_ORDER_INVENTORY_REJECTED": {
      if (action.meta?.requestId !== state.activeRequestId) {
        return state;
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload,
        activeRequestId: null,
      };
    }
    case "FETCH_ORDER_INVENTORY_FULFILLED": {
      if (action.meta?.requestId !== state.activeRequestId) {
        return state;
      }

      let orderInventory = {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        activeRequestId: null,
      };

      orderInventory.orderInventory = enrich(action.payload.data);
      orderInventory.lastQueryParameters = action.meta?.queryParameters || null;

      return orderInventory;
    }

    case "RESET_STATE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: null,
        lastQueryParameters: null,
        activeRequestId: null,
      };
    }

    default: {
      return { ...state };
    }
  }
}

function enrich(orderInventory) {
  orderInventory.forEach((item) => {
    item.value = item.itemId;
    item.displayValue = item.crItemCode + " - " + item.itemClassId;
    // delete item.itemKey
  });

  return orderInventory;
}
